import React from 'react'

const AuthError = ({error}) => {
    return <h6>An Error Occurred: {error.errorCode}</h6>;
};

export default AuthError;